import {
	AfterContentChecked,
	ContentChild,
	Directive,
	effect,
	input,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { PaginationTableColumnDisplayDirective } from './pagination-table-column-display.directive';
import { PaginationTableColumnExportDisplayDirective } from './pagination-table-column-export-display.directive';
import { PaginationTableColumnHeaderDirective } from './pagination-table-column-header.directive';
import { PaginationTableColumnSearchDirective } from './pagination-table-column-search.directive';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: 'ae-pgt-column',
})
export class PaginationTableColumnDirective<
	T,
	F extends {
		[K in keyof F]: AbstractControl<any>;
	} = any,
> implements AfterContentChecked {
	readonly disabled = input(false);
	readonly columnId = input.required<string>();
	readonly sortable = input(true);
	readonly alternateViews = input<[standard: string, alternate: string] | null>(
		null,
	);
	readonly starWidth = input(1);
	readonly fixedWidth = input<string | null>(null);
	readonly isDefault = input(false);
	readonly isAuxiliary = input(false);
	readonly isExportable = input(true);
	readonly autoTitle = input<
		boolean | ((item: T, columnId?: string) => string)
	>(true);
	readonly locked = input(false);

	@ContentChild(PaginationTableColumnHeaderDirective)
	public headerTemplate: PaginationTableColumnHeaderDirective;
	@ContentChild(PaginationTableColumnSearchDirective)
	public searchTemplate: PaginationTableColumnSearchDirective<T, F>;
	@ContentChild(PaginationTableColumnDisplayDirective)
	public displayTemplate: PaginationTableColumnDisplayDirective<T>;
	@ContentChild(PaginationTableColumnExportDisplayDirective)
	public exportDisplayTemplate: PaginationTableColumnExportDisplayDirective<T>;

	private onChange = new Subject<void>();
	public onChange$ = this.onChange.asObservable();

	constructor() {
		effect(() => {
			// Read all signals to track them
			this.disabled();
			this.columnId();
			this.sortable();
			this.alternateViews();
			this.starWidth();
			this.fixedWidth();
			this.isDefault();
			this.isAuxiliary();
			this.isExportable();
			this.autoTitle();
			this.locked();
			// Notify parent of changes
			this.onChange.next();
		});
	}

	ngAfterContentChecked(): void {
		if (this.headerTemplate == null) {
			throw Error(
				'ae-pgt-column is missing required child ae-pgt-column-header',
			);
		}
		if (this.displayTemplate == null) {
			throw Error(
				'ae-pgt-column is missing required child ae-pgt-column-display',
			);
		}
	}
}
